module.exports = __webpack_public_path__ + "img/ag-mobile.533c2d8d.svg";